import { isPropertyWithLinkValueTypeButStringValue, } from "@buildwithflux/models";
/**
 * This version of serde is introduced as we support a new type of property that has value of @see {LinkValue} type.
 *
 * We have a corresponding converter to handle serde between clients and
 * Firestore, @see {PropertyConverter.ts}, and this is to handle the snapshot world.
 *
 * NOTE we only handle the deserialization here, as we don't want to introduce a
 * new version schema tag, which is a bigger scope compared to support a new property value type.
 */
export class DocumentSnapshotWithLinkPropertySerde {
    serializationSchemaTag = "v0";
    /** @inheritDoc */
    intoStored(data) {
        return {
            __metadata: {
                schemaTag: this.serializationSchemaTag,
            },
            ...data,
        };
    }
    /** @inheritDoc */
    fromStored(data) {
        const properties = data.properties;
        const elements = data.elements;
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.keys(properties).forEach((key) => {
            const property = properties[key];
            if (isPropertyWithLinkValueTypeButStringValue(property)) {
                properties[key].value = {
                    type: "link",
                    text: property.value,
                    url: property.value,
                };
            }
        });
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.keys(elements).forEach((key) => {
            const elementProperties = elements[key]?.properties;
            if (!elementProperties)
                return;
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            Object.keys(elementProperties).forEach((key) => {
                const elementProperty = elementProperties[key];
                if (isPropertyWithLinkValueTypeButStringValue(elementProperty)) {
                    elementProperties[key].value = {
                        type: "link",
                        text: elementProperty.value,
                        url: elementProperty.value,
                    };
                }
            });
        });
        return {
            ...data,
            properties,
            elements,
        };
    }
}
//# sourceMappingURL=DocumentSnapshotWithLinkPropertySerde.js.map